import React from 'react';

// 所有图标组件的接口
interface IconProps {
  size?: number;
  className?: string;
  color?: string;
}

// Grid3x3 图标
export const Grid3x3: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="9" y="3" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="15" y="3" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="3" y="9" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="9" y="9" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="15" y="9" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="3" y="15" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="9" y="15" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
    <rect x="15" y="15" width="6" height="6" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

// Target 图标
export const Target: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="12" r="6" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="12" r="2" stroke={color} strokeWidth="2"/>
  </svg>
);

// Download 图标
export const Download: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" stroke={color} strokeWidth="2"/>
    <polyline points="7,10 12,15 17,10" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="15" x2="12" y2="3" stroke={color} strokeWidth="2"/>
  </svg>
);

// Activity 图标
export const Activity: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="22,12 18,12 15,21 9,3 6,12 2,12" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

// HelpCircle 图标
export const HelpCircle: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="17" x2="12.01" y2="17" stroke={color} strokeWidth="2"/>
  </svg>
);

// X 图标
export const X: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="18" y1="6" x2="6" y2="18" stroke={color} strokeWidth="2"/>
    <line x1="6" y1="6" x2="18" y2="18" stroke={color} strokeWidth="2"/>
  </svg>
);

// Plus 图标
export const Plus: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="12" y1="5" x2="12" y2="19" stroke={color} strokeWidth="2"/>
    <line x1="5" y1="12" x2="19" y2="12" stroke={color} strokeWidth="2"/>
  </svg>
);

// List 图标
export const List: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <line x1="8" y1="6" x2="21" y2="6" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="12" x2="21" y2="12" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="18" x2="21" y2="18" stroke={color} strokeWidth="2"/>
    <line x1="3" y1="6" x2="3.01" y2="6" stroke={color} strokeWidth="2"/>
    <line x1="3" y1="12" x2="3.01" y2="12" stroke={color} strokeWidth="2"/>
    <line x1="3" y1="18" x2="3.01" y2="18" stroke={color} strokeWidth="2"/>
  </svg>
);

// Eye 图标
export const Eye: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke={color} strokeWidth="2"/>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2"/>
  </svg>
);

// EyeOff 图标
export const EyeOff: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke={color} strokeWidth="2"/>
    <line x1="1" y1="1" x2="23" y2="23" stroke={color} strokeWidth="2"/>
  </svg>
);

// Square 图标
export const Square: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

// Box 图标
export const Box: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" stroke={color} strokeWidth="2"/>
    <polyline points="3.27,6.96 12,12.01 20.73,6.96" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="22.08" x2="12" y2="12" stroke={color} strokeWidth="2"/>
  </svg>
);

// MoreHorizontal 图标
export const MoreHorizontal: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="1" stroke={color} strokeWidth="2"/>
    <circle cx="19" cy="12" r="1" stroke={color} strokeWidth="2"/>
    <circle cx="5" cy="12" r="1" stroke={color} strokeWidth="2"/>
  </svg>
);

// Settings 图标
export const Settings: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke={color} strokeWidth="2"/>
  </svg>
);

// Zap 图标
export const Zap: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

// Move 图标
export const Move: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="5,9 2,12 5,15" stroke={color} strokeWidth="2"/>
    <polyline points="9,5 12,2 15,5" stroke={color} strokeWidth="2"/>
    <polyline points="15,19 12,22 9,19" stroke={color} strokeWidth="2"/>
    <polyline points="19,9 22,12 19,15" stroke={color} strokeWidth="2"/>
    <line x1="2" y1="12" x2="22" y2="12" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="2" x2="12" y2="22" stroke={color} strokeWidth="2"/>
  </svg>
);

// RotateCcw 图标
export const RotateCcw: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <polyline points="1,4 1,10 7,10" stroke={color} strokeWidth="2"/>
    <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" stroke={color} strokeWidth="2"/>
  </svg>
);

// ZoomIn 图标
export const ZoomIn: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2"/>
    <path d="M21 21l-4.35-4.35" stroke={color} strokeWidth="2"/>
    <line x1="11" y1="8" x2="11" y2="14" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="11" x2="14" y2="11" stroke={color} strokeWidth="2"/>
  </svg>
);

// ZoomOut 图标
export const ZoomOut: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="11" cy="11" r="8" stroke={color} strokeWidth="2"/>
    <path d="M21 21l-4.35-4.35" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="11" x2="14" y2="11" stroke={color} strokeWidth="2"/>
  </svg>
);

// Home 图标
export const Home: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke={color} strokeWidth="2"/>
    <polyline points="9,22 9,12 15,12 15,22" stroke={color} strokeWidth="2"/>
  </svg>
);

// Info 图标
export const Info: React.FC<IconProps> = ({ size = 24, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="16" x2="12" y2="12" stroke={color} strokeWidth="2"/>
    <line x1="12" y1="8" x2="12.01" y2="8" stroke={color} strokeWidth="2"/>
  </svg>
);

// 确保所有图标都被正确导出
export const icons = {
  Grid3x3,
  Target,
  Download,
  Activity,
  HelpCircle,
  X,
  Plus,
  List,
  Eye,
  EyeOff,
  Square,
  Box,
  MoreHorizontal,
  Settings,
  Zap,
  Move,
  RotateCcw,
  ZoomIn,
  ZoomOut,
  Home,
  Info
};

// 默认导出所有图标
export default icons;
